import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);

export function changeTimeStringToDateFormat(hour: number, minute?: number) {
    const currentTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const firstDayOfYear = dayjs().set('month', 0).set('date', 2).format('YYYY-MM-DD');
    const baseDate = dayjs(firstDayOfYear)
        .utc()
        .hour(hour)
        .minute(minute ?? 0)
        .second(0)
        .tz(currentTimeZone ?? 'Asia/Kolkata');
    return baseDate.toISOString();
}

export function getAMPMTime(isoDatetime: string, withMinutes?: boolean): string {
    const date = dayjs(isoDatetime).utc();

    if (!date.isValid()) {
        // Invalid datetime string
        return 'Invalid datetime';
    }

    const hours = date.format('h');
    const ampm = date.format('A');
    const minutes = date.format('mm');

    // Format the time in AM/PM
    const formattedTime = withMinutes ? `${hours}:${minutes} ${ampm}` : `${hours} ${ampm}`;

    return formattedTime;
}

export const isSameDayAsToday = (value: Date) => dayjs(value).isSame(new Date(), 'date');

export const getMinutesBetweenDates = (startDate: string, endDate: string): number => {
    const start = dayjs(startDate);
    const end = dayjs(endDate);
    return end.diff(start, 'minute');
};
